export const initTextCardFields = (text_card) => {
  if (!text_card) return;

  if (!text_card.icon) text_card.icon = {};
  if (text_card.icon.width === undefined) text_card.icon.width = undefined;
  if (text_card.icon.height === undefined) text_card.icon.height = undefined;

  if (!text_card.title) text_card.title = {};
  if (text_card.title.fontSize === undefined)
    text_card.title.fontSize = undefined;
  if (text_card.title.color === undefined) text_card.title.color = undefined;
  if (text_card.title.bold === undefined) text_card.title.bold = undefined;

  if (!text_card.content) text_card.content = {};
  if (text_card.content.fontSize === undefined)
    text_card.content.fontSize = undefined;

  if (!text_card.action) text_card.action = {};
  if (text_card.action.link === undefined) text_card.action.link = undefined;
  if (text_card.action.popup_id === undefined)
    text_card.action.popup_id = undefined;
  if (text_card.action.title_link === undefined)
    text_card.action.title_link = undefined;
  if (text_card.action.title_popup_id === undefined)
    text_card.action.title_popup_id = undefined;
};

export const initScoreFields = (score) => {
  if (!score) return;

  if (score.show_star === undefined) {
    score.show_star = undefined;
  }

  if (!score.value) score.value = {};
  if (score.value.fontSize === undefined) score.value.fontSize = undefined;
  if (score.value.color === undefined) score.value.color = undefined;

  if (!score.sub_title) score.sub_title = {};
  if (score.sub_title.text === undefined) score.sub_title.text = undefined;
  if (score.sub_title.fontSize === undefined)
    score.sub_title.fontSize = undefined;
  if (score.sub_title.color === undefined) score.sub_title.color = undefined;

  if (!score.action) score.action = {};
  if (score.action.link === undefined) score.action.link = undefined;
  if (score.action.popup_id === undefined) score.action.popup_id = undefined;
};
